import { TextAppearanceKeys, TextEmphasisKeys, TextSizeKeys } from '@/constants/enum';
import { textAppereances, textEmphasis, textSizes } from '@/constants/textStyles';

interface IProps {
  textSize: TextSizeKeys;
  textAppearance: TextAppearanceKeys;
  textEmphasis: TextEmphasisKeys;
  changeTextSize: (value: TextSizeKeys) => void;
  changeTextAppearance: (value: TextAppearanceKeys) => void;
  changeTextEmphasis: (value: TextEmphasisKeys) => void;
  title?: string;
}

interface IButtonProps {
  style?: {
    fontSize?: string;
    fontStyle?: string;
    color?: string;
    fontWeight?: string;
  };
  content: string;
  selected?: boolean;
  handleClick: () => void;
}

function ButtonStyle(props: IButtonProps) {
  return (
    <div
      style={{
        height: '40px',
        padding: '0 15px',
        border: props.selected ? '2px solid #005BD3' : '1px solid var(--Color-input-border, #8A8A8A)!important',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        ...props.style,
      }}
      onClick={props.handleClick}
    >
      {props.content}
    </div>
  );
}

export default function UpdateTextStyle(props: IProps) {
  return (
    <>
      <div className="mt-8">
        <p>{(props.title ? props.title + ' - ' : '') + 'Size'}</p>
      </div>
      <div className="mt-8 editor-icon-container" style={{ gap: '8px' }}>
        {textSizes.map((size) => {
          if (size.id === TextSizeKeys.base) {
            return (
              <ButtonStyle
                handleClick={() => props.changeTextSize(size.id)}
                selected={props.textSize === size.id}
                key={size.id}
                content={size.name}
              />
            );
          }
          return (
            <ButtonStyle
              handleClick={() => props.changeTextSize(size.id)}
              selected={props.textSize === size.id}
              key={size.id}
              content={size.name}
              style={{ fontSize: size.fontSize }}
            />
          );
        })}
      </div>

      <div className="mt-8">
        <p>{(props.title ? props.title + ' - ' : '') + 'Color'}</p>
      </div>
      <div className="mt-8 editor-icon-container" style={{ gap: '8px' }}>
        {textAppereances.map((text) => {
          if (text.id === TextAppearanceKeys.base) {
            return (
              <ButtonStyle
                handleClick={() => props.changeTextAppearance(text.id)}
                selected={props.textAppearance === text.id}
                key={text.id}
                content={text.name}
                style={{ fontWeight: 'bold' }}
              />
            );
          }
          return (
            <ButtonStyle
              handleClick={() => props.changeTextAppearance(text.id)}
              selected={props.textAppearance === text.id}
              key={text.id}
              content={text.name}
              style={{ color: text.color, fontWeight: 'bold' }}
            />
          );
        })}
      </div>

      <div className="mt-8">
        <p>{(props.title ? props.title + ' - ' : '') + 'Emphasis'}</p>
      </div>
      <div className="mt-8 editor-icon-container" style={{ gap: '8px' }}>
        {textEmphasis.map((text) => {
          if (text.id === TextEmphasisKeys.base) {
            return (
              <ButtonStyle
                handleClick={() => props.changeTextEmphasis(text.id)}
                selected={props.textEmphasis === text.id}
                key={text.id}
                content={text.name}
                style={{}}
              />
            );
          }
          return (
            <ButtonStyle
              handleClick={() => props.changeTextEmphasis(text.id)}
              selected={props.textEmphasis === text.id}
              key={text.id}
              content={text.name}
              style={{
                fontStyle: text.style !== 'bold' ? text.style : undefined,
                fontWeight: text.style === 'bold' ? text.style : undefined,
              }}
            />
          );
        })}
      </div>
    </>
  );
}
